import { objectWithoutProperties as _objectWithoutProperties, defineProperty as _defineProperty, extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';
import { marginBottomLevels, getMarginBottomClass } from '../../utils/marginBottom/index.js';
import styles from './icon.css.js';

var Icon = function Icon(_ref) {
  var _cn;

  var Svg = _ref.svg,
      _ref$inline = _ref.inline,
      inline = _ref$inline === void 0 ? false : _ref$inline,
      _ref$scaled = _ref.scaled,
      scaled = _ref$scaled === void 0 ? false : _ref$scaled,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? '1.125em' : _ref$width,
      _ref$marginBottom = _ref.marginBottom,
      marginBottom = _ref$marginBottom === void 0 ? inline || scaled ? 0 : 2 : _ref$marginBottom,
      rest = _objectWithoutProperties(_ref, ["svg", "inline", "scaled", "width", "marginBottom"]);

  return React.createElement("span", {
    className: cn(styles.iconWrapper, getMarginBottomClass(marginBottom), (_cn = {}, _defineProperty(_cn, styles['inline'], inline), _defineProperty(_cn, styles['scaled'], scaled), _cn))
  }, React.createElement(Svg, _extends({
    "aria-hidden": "true",
    className: cn(styles.Icon, _defineProperty({}, styles['Icon--scaled'], scaled)),
    focusable: "false",
    role: "img",
    version: "1.1",
    width: width,
    height: width,
    viewBox: "0 0 18 18"
  }, rest)));
};

Icon.displayName = 'Icon';
Icon.propTypes = process.env.NODE_ENV !== "production" ? {
  /** docgen-ignore */
  svg: PropTypes.func.isRequired,
  inline: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  /**
   * 0, 1, 2, 3, 4, 5, 6, 7
   */
  marginBottom: PropTypes.oneOf(marginBottomLevels),
  scaled: PropTypes.bool
} : {};
export default Icon;